module.exports = __webpack_public_path__ + "static/media/facebook.4dd15669.svg";